<!--
* @Author: zhangping
* @Date: 2025-09-28 13:40:04
* @Description: 查看物流弹框
-->

<template>
    <Modal v-model="isShow" footer-hide>
        <h3>{{ logisticsInfo.logisticsStatusStr }}</h3>
        <p>{{ `${logisticsInfo.logisticsCompany} ${logisticsInfo.logisticsNo}` }}</p>
        <div class="timeline-wrapper">
            <Timeline v-if="logisticsInfo.expInfos && logisticsInfo.expInfos.length">
                <TimelineItem
                    v-for="(item, index) in logisticsInfo.expInfos"
                    :key="index"
                    :color="index === 0 ? 'blue' : '#999'"
                >
                    <p class="time">{{ item.time || '-' }}</p>
                    <p class="context">{{ item.context || '-' }}</p>
                </TimelineItem>
            </Timeline>
            <p v-else>暂无物流</p>
        </div>
    </Modal>
</template>

<script>
import { apiOrderLogisticsInfo } from '@/api/purchase';
export default {
    data() {
        return {
            isShow: false,
            logisticsInfo: {}, // 查看的物流信息
        };
    },
    methods: {
        open(row) {
            this.isShow = true;
            this.getLogisticsInfo(row.id);
        },
        // 获取物料信息
        async getLogisticsInfo(orderId) {
            const res = await apiOrderLogisticsInfo(orderId);
            this.logisticsInfo = res;
            this.isShow = true;
        },
    },
};
</script>

<style lang="less" scoped>
.timeline-wrapper {
    margin-top: 12px;
    max-height: 400px;
    overflow-y: auto;
    .ivu-timeline-item {
        &:first-child {
            color: #2d8cf0;
        }
    }
}
</style>
<style lang="less">
.order-list {
    .ivu-tabs-nav-scroll {
        background: #fff;
        padding: 13px 15px;
    }
}
</style>
